module.exports = __webpack_public_path__ + "static/media/member-services-icon-active.33f3e055.svg";